import React, { Component, Fragment } from "react";
import { Container, Image } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import cart from "../../../assets/images/icon-cart-small.svg";
// import { useTranslation,withTranslation } from 'react-i18next';
import Button from "../../../components/UI/Button/Button";
import Modal from "../../../components/UI/Modal/Modal";
import NetworkAlert from "../../../components/UI/NetworkAlert/NetworkAlert";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Textarea from "../../../components/UI/Textarea/Textarea";
import { logFirebaseEvent } from "../../../shared/utility";
import * as procedureActions from "../../../store/actions/index";
import DiscardBilling from "../../BalanceBilling/DiscardBilling/DiscardBilling";
import UploadSuccessful from "../../BalanceBilling/UploadSuccessful/UploadSuccessful";
import classes from "./Questionnaire.module.css";


interface IParentProps {
  procedureFormData: {};
  t: any;
}
interface IStateFromProps {
  // t:any;
  procedureQuestionnaire: {
    statusCode: number;
    result: {
      id: string;
      question: string;
      order: number;
    }[];
  };
  error: boolean;
  loading: boolean;
  loadingQuestionnaire: boolean;
  submitted: boolean;
}
interface IDispatchFromProps {
  onFetchProcedureQuestionnaire: () => void;
  onSubmitProcedureShopper: (formdata: {}) => void;
}

type Props = IParentProps &
  IStateFromProps &
  IDispatchFromProps &
  RouteComponentProps;
class Questionnaire extends Component<Props> {
  state = {
    additionalInfo: "",
    errorAdditionalInfo: "",
    preferredNumber: "",
    errorPreferredNumber: "",
    additionalInfoVisibility: true,
    userAnswers: [] as { questionId: string; answer: boolean }[],
    submittingProcedureShopper: false,
    discardingBills: false,
  };
  componentDidMount() {
    this.props.onFetchProcedureQuestionnaire();
  }
  handleChange = (e) => {
    console.log("e.target.name", e.target.name, e.target.value);
    this.setState({ formValid: false });
    this.setState({
      [e.target.name]: e.target.value,
      errorPreferredNumber: "",
    });
  };
  validateForm = () => {
    let preferredNumber = this.state.preferredNumber;
    let formIsValid = true;
    const { t } = this.props;

    let phonePattern = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/; // (123) 123-1234;
    if (
      (preferredNumber && !phonePattern.test(preferredNumber)) ||
      preferredNumber === ""
    ) {
      formIsValid = false;
      this.setState({
        errorPreferredNumber: t("errorMsg.errorPhone"),
      });
    }
    return formIsValid;
  };
  onChangeProcedureQuesHandler = (event, res) => {
    console.log("event.target.checked", event.target.checked);
    if (!event.target.checked) {
      let answers = this.state.userAnswers
        .map((answer) => answer)
        .filter((answer) => answer.questionId !== event.target.id);
      console.log("answers", answers);
      this.setState({
        userAnswers: [...answers],
      });
      console.log(
        this.props.procedureQuestionnaire &&
          this.props.procedureQuestionnaire.result.length,
        " " + res.order
      );
      if (
        res.order ===
        (this.props.procedureQuestionnaire &&
          this.props.procedureQuestionnaire.result.length)
      ) {
        this.setState({ additionalInfoVisibility: true });
      }
    } else {
      let answers = this.state.userAnswers.map((answer) => answer);
      console.log("answers", answers);
      this.setState({
        userAnswers: [
          ...answers,
          { questionId: event.target.id, answer: true },
        ],
      });
      console.log(
        "else",
        this.props.procedureQuestionnaire &&
          this.props.procedureQuestionnaire.result.length,
        " " + res.order
      );
      if (
        res.order ===
        (this.props.procedureQuestionnaire &&
          this.props.procedureQuestionnaire.result.length)
      ) {
        this.setState({ additionalInfoVisibility: false });
        this.setState({ additionalInfo: "" });
      }
    }
  };
  
  handleSubmit = (e) => {
    console.log(this.props.procedureFormData);
    e.preventDefault();
    if (this.validateForm()) {
      logFirebaseEvent("ProcedureShopperSubmitButtonPressed");
      this.setState({ formValid: true });
      const procedureFormData = this.props.procedureFormData;
      const { additionalInfo, userAnswers, preferredNumber } = this.state;

      const defaultUserAnswers = this.props.procedureQuestionnaire.result.map(
        (res) => ({
          questionId: res.id,
          answer: false,
        })
      );

      const finalAnswers = defaultUserAnswers.map(
        (obj) => userAnswers.find((o) => o.questionId === obj.questionId) || obj
      );
      console.log(finalAnswers);

      const formData = {
        ...procedureFormData,
        userAnswers:
          userAnswers.length !== 0 ? finalAnswers : defaultUserAnswers,
        additionalInformation: additionalInfo,
        preferedContactNumber: preferredNumber.replace(/[^0-9]/g, ""),
        userId: localStorage.getItem("userId"),
      };
      console.log(...userAnswers);
      console.log(formData);

      this.props.onSubmitProcedureShopper(formData);
      this.setState({ submittingProcedureShopper: true });
    }
  };
  submitDoneHandler = () => {
    this.setState({ submittingProcedureShopper: false });
    this.props.history.push("/");
  };

  discardBillsHandler = () => {
    this.setState({ discardingBills: true });
  };
  donotDiscardBillsHandler = () => {
    this.setState({ discardingBills: false });
  };
  confirmDiscardBillsHandler = () => {
    this.setState({ discardingBills: false });
    this.props.history.push("/");
  };
  render() {
    const { t } = this.props;
    const nextBtnStyle = {
      margin: "5px",
    };
    const modalDiscard = {
      width: "350px",
      left: "calc(50% - 175px)",
    };
    const modalChildStyle = {};
    console.log(...this.state.userAnswers);
    let additionalInfoDisplay: any;
    if (this.state.additionalInfoVisibility) {
      additionalInfoDisplay = (
        <div className={classes.displySec}>
          {/* {t('Please specify your needs (Optional)')} */}
          <Textarea
            label={t("procedureShopper.textArea")}
            supportLabel=""
            placeholder=""
            elementLabelStyle={{}}
            elementInputStyle={{}}
            name="additionalInfo"
            errorText={this.state.errorAdditionalInfo}
            value={this.state.additionalInfo}
            onChange={(e) => this.handleChange(e)}
          />
          <div className="form-group phone">
            <label className="form-label font14 block-element">
              {t("procedureShopper.contactNumber")}
            </label>
            <NumberFormat
              format="(###) ###-####"
              placeholder={t("submitBill.phone") + "(###) ###-####"}
              name="preferredNumber"
              value={this.state.preferredNumber}
              className="form-control"
              onChange={(e) => this.handleChange(e)}
            />
            <span className="errorMsg">{this.state.errorPreferredNumber}</span>
          </div>
        </div>
      );
    }

    let submitProcedureShopper: any;
    if (this.props.submitted) {
      submitProcedureShopper = (
        <Modal
          show={this.state.submittingProcedureShopper}
          childComp={
            <UploadSuccessful
              modalClosed={this.submitDoneHandler}
              heading={t("questionaire.thankYou")}
              subHeading={t("questionaire.thanksDescription")}
            />
          }
          style={modalChildStyle}
        />
      );
    }

    /* Error Modal */
    let errorDisplay: any;
    if (this.props.error) {
      console.log(this.props.error);
      errorDisplay = (
        <Modal
          show={this.state.submittingProcedureShopper}
          childComp={
            <NetworkAlert
              modalClosed={this.submitDoneHandler}
              error={t("errorMsg.networkError")}
            />
          }
          style={modalChildStyle}
        />
      );
    }
    let spinner: any;
    // console.log("this.props.loading", this.props.loading);
    if (this.props.loadingQuestionnaire || this.props.loading) {
      spinner = <Spinner />;
    }
    let procedureQues: any;
    if (
      this.props.procedureQuestionnaire &&
      this.props.procedureQuestionnaire.result
    ) {
      procedureQues = this.props.procedureQuestionnaire.result.map((res) => {
        console.log(res.question);
        return (
          <ul key={res.id}>
            <li>{res.question}</li>
            <li>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={`${res.id}`}
                  onChange={(e) => this.onChangeProcedureQuesHandler(e, res)}
                />
                <span className="switchUnChecked">{t("claims.no")}</span>
                <label
                  className="custom-control-label"
                  htmlFor={`${res.id}`}
                ></label>
                <span className="switchChecked">{t("claims.yes")}</span>
              </div>
            </li>
          </ul>
        );
      });
    }
    let notificationInfo: any;
    if (!this.state.additionalInfoVisibility) {
      notificationInfo = (
        <div className={classes.uploadList}>
          <ul>
            <li>{t("questionaire.emergencyText")}</li>
            <li>{t("questionaire.threateningText")}</li>
          </ul>
        </div>
      );
    }
    const discardBills = (
      <Modal
        show={this.state.discardingBills}
        childComp={
          <DiscardBilling
            cancelDiscard={this.donotDiscardBillsHandler}
            confirmDiscard={this.confirmDiscardBillsHandler}
          />
        }
        style={modalDiscard}
      />
    );
    let questionnaire: any;
    questionnaire = (
      <Container fluid>
        {submitProcedureShopper}
        {errorDisplay}
        {spinner}
        {discardBills}
        <div className="inner-banner">
          <div className="inner-banner-title">
            <h3>{t("support.procedureShoper")}</h3>
            <Image
              src={cart}
              alt="cart"
              className={classes.stockimage}
              data-test="stockIMG"
            />
          </div>
          <div className="mainContainer mainContainerL">
            <div className="text-center">
              <h6 className="bill-heading">
                {t("procedureShopper.questionnaire")}
              </h6>
            </div>
            <div className={classes.queList}>{procedureQues}</div>
            {additionalInfoDisplay}
            {notificationInfo}

            <div className="text-center">
              <Button
                label={t("submitBill.discard")}
                clicked={this.discardBillsHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <Button
                label={t("submitBill.submit")}
                clicked={this.handleSubmit}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={!this.state.additionalInfoVisibility}
              />
            </div>
          </div>
        </div>
      </Container>
    );
    return <Fragment>{questionnaire}</Fragment>;
  }
}

const mapStateToProps = (state: any) => ({
  procedureQuestionnaire: state.procedureQuestionnaire.procedureQuestionnaire,
  error: state.submitProcedureShopper.error,
  loading: state.submitProcedureShopper.loading,
  submitted: state.submitProcedureShopper.submitted,
  loadingQuestionnaire: state.procedureQuestionnaire.loading,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchProcedureQuestionnaire: () =>
    dispatch(procedureActions.fetchProcedureQuestionnaire()),
  onSubmitProcedureShopper: (formdata) =>
    dispatch(procedureActions.submitProcedureShopper(formdata)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Questionnaire));
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Questionnaire));
